import { render, staticRenderFns } from "./WeeklyHeatmapTable.vue?vue&type=template&id=31dd689a"
import script from "./WeeklyHeatmapTable.vue?vue&type=script&lang=js"
export * from "./WeeklyHeatmapTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports